import React from 'react';
import {Link} from "react-router-dom";
import './css/Ville.css';
function Ville() {
    return (
        <div className="back">
            <Link to="/Search/sea=&city=Casablanca&catégories=0" className="b">
                <p>Casablanca</p>
            </Link>
            <Link to="/Search/sea=&city=Casablanca&catégories=0" className="b">
                <p>Agadir</p>
            </Link>
            <Link to="/Search/sea=&city=Bouskoura&catégories=0" className="b">
                <p>Bouskoura</p>
            </Link>
            <Link to="/Search/sea=&city=Mediouna&catégories=0" className="b">
                <p>Mediouna</p>
            </Link>
            <Link to="/Search/sea=&city=Mohammedia&catégories=0" className="b">
                <p>Mohammedia</p>
            </Link>
            <Link to="/Search/sea=&city=Nouaceur&catégories=0" className="b">
                <p>Nouaceur</p>
            </Link>
            <Link to="/Search/sea=&city=Tamaris&catégories=0" className="b">
                <p>Tamaris</p>
            </Link>
            <Link to="/Search/sea=&city=El Majjatia Ouled Taleb&catégories=0" className="b">
                <p>El Majjatia Ouled Taleb</p>
            </Link>
            <Link to="/Search/sea=&city=Lahraouyine&catégories=0" className="b">
                <p>Lahraouyine</p>
            </Link>
            <Link to="/Search/sea=&city=Sidi Hajjaj Oued Hassar&catégories=0" className="b">
                <p>Sidi Hajjaj Oued Hassar</p>
            </Link>
            <Link to="/Search/sea=&city=Tit Mellil&catégories=0" className="b">
                <p>Tit Mellil</p>
            </Link>
            <Link to="/Search/sea=&city=Dar Bouazza&catégories=0" className="b">
                <p>Dar Bouazza</p>
            </Link>
            <Link to="/Search/sea=&city=Errahma&catégories=0" className="b">
                <p>Errahma</p>
            </Link>
            <Link to="/Search/sea=&city=Lamkansa&catégories=0" className="b">
                <p>Lamkansa</p>
            </Link>
            <Link to="/Search/sea=&city=Oulad Salah&catégories=0" className="b">
                <p>Oulad Salah</p>
            </Link>
            <Link to="/Search/sea=&city=Béni Yakhlef&catégories=0" className="b">
                <p>Béni Yakhlef</p>
            </Link>
            <Link to="/Search/sea=&city=Sidi Moussa Ben Ali&catégories=0" className="b">
                <p>Sidi Moussa Ben Ali</p>
            </Link>
            <Link to="/Search/sea=&city=Sidi Moussa El Majdoub&catégories=0" className="b">
                <p>Sidi Moussa El Majdoub</p>
            </Link>
            <Link to="/Search/sea=&city=3&catégories=0" className="b">
                <p>Autre ville...</p>
            </Link>
        
        </div>
    )
}

export default Ville
